export const getObjectKeys = <T extends Record<string, unknown>>(
  obj: T
): Array<keyof T> => {
  return Object.keys(obj) as Array<keyof T>;
};

export function isNullOrUndefined(value: unknown): boolean {
  return value === null || value === undefined;
}
